<template>
	<div>
		<transition name="fade" v-on:after-leave="modalDestroyed">
			<div v-if="$vmodal.isOpen" class="v-modal-wrapper">
				<div class="v-modal-scroll-region" data-modal-scroll-region>
					<div
						class="v-modal-padding" data-modal-padding
						@click.self="$vmodal.dismissViaBackgroundClick()">
						<ModalComponent
							ref="modalComponent"
							:component="$vmodal.options.component"
							:props="$vmodal.options.props"
							@modalMounted="modalMounted"/>
					</div>
				</div>
				<div
					:style="backgroundStyle"
					class="v-modal-backdrop"/>
			</div>
		</transition>
	</div>
</template>
<script>
import ModalComponent from "@/packages/vmodal/ModalComponent.vue";

export default {
	components: {
		ModalComponent,
	},

	computed: {
		backgroundStyle() {
			return {
				backgroundColor: this.$vmodal.options.backgroundColor,
				opacity: this.$vmodal.options.opacity,
			};
		},
	},

	methods: {
		modalMounted() {
			this.$vmodal.executeCallback();
		},
		modalDestroyed() {
			if (this.$vmodal.options.destroyed) {
				this.$vmodal.options.destroyed.call();
			}
			this.$vmodal.executeCallback();
		},
	},
};
</script>
<style>
.v-modal-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 997;
	overflow: hidden;
}

.v-modal-scroll-region {
	width: 100%;
	height: 100%;
	overflow: hidden;
	overflow-y: scroll;
	scrollbar-gutter: stable both-edges;
}

.v-modal-padding {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100%;
}

.v-modal-alignment {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
}

.v-modal-backdrop {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: -1;
}

.v-modal {
	position: relative;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.4s ease;
	opacity: 1;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
